export const en = {
    "create-alice-skill": "Create Alice skill",
    "create-auto-app": "Create Auto application",
    "create-smart-home": "Create Smart home",
    "create-smart-screen-app": "Create Duo application",
    "create-tv-app": "Create TV application",
    "applications": "Applications",
    "published-version": "Published version",
    "new-version": "New version",
    "new-app": "New application",
    "main-information": "Main Information",
    "about-application": "About Application",
    "about-skill": "About",
    "application": "Application",
    "assets": "Assets",
    "agreements": "Agreements",
    "feature-flags": "Feature Flags",
    "analytics": "Analytics",
    "feedback": "Feedback",
    "docs": "Documentation",
    "yandex-copyright": "© {year} Yandex LLC",
    "app-metrica-settings": "AppMetrica settings",
    "from-whom-you-want-to-create": "As what type of entity do you want to create the application?",
    "private-person": "Individual",
    "porg-representative": "Legal entity",
    "you-are-private":  "You are authorized as an individual",
    "you-are-porg":  "You are authorized as a legal entity",
    "how-to-login-as-private":  "[Instructions] for authorizing as an individual",
    "how-to-login-as-porg": "[Instructions] for authorizing as a legal entity",
    "cancel": "Cancel",
    "create": "Create",
    "terms-of-use-checkbox-label": "I have read and accept the [Yandex.Dialogs Service Terms of Use]",
    "max-apps-error": "Maximum number of applications reached"
} as const;
export const ru = {
    "create-alice-skill": "Создать навык Алисы",
    "create-auto-app": "Создать Авто приложение",
    "create-smart-home": "Создать навык Умного дома",
    "create-smart-screen-app": "Создать Duo приложение",
    "create-tv-app": "Создать ТВ приложение",
    "applications": "Приложения",
    "published-version": "Опубликованная версия",
    "new-version": "Новая версия",
    "new-app": "Новое приложение",
    "main-information": "Основная информация",
    "about-application": "О приложении",
    "about-skill": "О навыке",
    "application": "Приложение",
    "assets": "Ресурсы",
    "agreements": "Соглашения",
    "feature-flags": "Фича-флаги и редакторские поля",
    "analytics": "Аналитика",
    "feedback": "Обратная связь",
    "docs": "Документация",
    "yandex-copyright": "© {year} ООО «Яндекс»",
    "app-metrica-settings": "Настройки AppMetrica",
    "from-whom-you-want-to-create": "От какого лица вы хотите создать приложение?",
    "private-person": "Физическое лицо",
    "porg-representative": "Юридическое лицо",
    "you-are-private": "Вы авторизованы как физическое лицо",
    "you-are-porg": "Вы авторизованы как юридическое лицо",
    "how-to-login-as-private": "[Инструкция] по авторизации как физическое лицо",
    "how-to-login-as-porg": "[Инструкция] по авторизации как юридическое лицо",
    "cancel": "Отмена",
    "create": "Создать",
    "terms-of-use-checkbox-label": "Я ознакомлен(-а) и принимаю [Условия использования сервиса Яндекс.Диалоги]",
    "max-apps-error": "Достигнуто максимальное количество приложений"
} as const;
